export const MAX_HIGH_QUALITY_PARTICIPANTS = 4;
export const MAX_HIGH_QUALITY_PARTICIPANTS_WITH_VIDEO_OPTIMIZATION = 8;
